import { useEffect, useState } from "react";
import AvatarGroup from "@atlaskit/avatar-group";
import styles from "./AvatarGroup.module.scss"

const AvtarGroupComponent = (props) => {
    const [intData, setIntData] = useState([])
    useEffect(() => {
        if (props?.interviewers && props?.interviewers?.length > 0) {
            const dt = props?.interviewers.map((d) => ({
                id: d.id,
                src: d?.avtar && d?.avtar?.url?d?.avtar?.url:`https://ui-avatars.com/api/?size=48&background=0D8ABC&color=fff&name=${encodeURI(
                    d?.name,
                  )}`,
                key: d.id,
                name: d.name,
                href: "#"
            }));
            setIntData(dt)
        }
    }, [props?.interviewers])
    return (
        <div className={styles.avatarcomp}>
            <AvatarGroup
                appearance="stack"
                data={intData}
                size="small"
            />
        </div>
    )
}

export default AvtarGroupComponent;